import * as angular from 'angular';

import { ISeriesBuilder, ISeriesBuilderArguments } from './ISeriesBuilder';
import { SeriesMappingResult } from '.';
import { bindingResultErrorToWideError } from '../../common/';
import { ApprovalTableConfiguration } from '../../widgets/approvalTable/approvalTable.configuration';

export interface IApprovalTableService extends ISeriesBuilder {
}

export class ApprovalTableService implements IApprovalTableService {
    static serviceId = 'approvalTableService';

    static $inject = ['$q'];
    constructor(private _$q: angular.IQService) {
    }

    buildSeriesFromViewModels(args: ISeriesBuilderArguments): angular.IPromise<SeriesMappingResult<any>> {
        const { groups, map, errors } = args;
        const configuration = args.configuration as ApprovalTableConfiguration;
        let groupGuid = configuration.groupGuid;
        if (configuration.isBoundToGroup && map && map[groupGuid]) {
            groupGuid = map[groupGuid];
        }
        const group = groups[groupGuid];
        const vms = group ? [group] : [];

        let error;
        if (errors) {
            const bindMissing = errors[configuration.groupGuid];
            if (bindMissing) {
                error = bindingResultErrorToWideError([bindMissing]);
            }
        }
        return this._$q.when({
            error,
            series: vms,
            map
        });
    }
}